// extracted by css-extract-rspack-plugin
export default {"cls1":"SingleClaimPage-cls1_i_e","cls2":"SingleClaimPage-cls2_pb3 SingleClaimPage-cls1_i_e"};